import { render } from "./categoryAtlas.vue?vue&type=template&id=4e47d43a&scoped=true"
import script from "./categoryAtlas.vue?vue&type=script&lang=js"
export * from "./categoryAtlas.vue?vue&type=script&lang=js"

import "./categoryAtlas.vue?vue&type=style&index=0&id=4e47d43a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e47d43a"]])

export default __exports__